import { getStationCode } from "../network/NetworkUtil";

export const ROUTE_STATUS_TAB_METRIC_KEY = "SCC_OUTBOUND_ROUTE_STATUS_TAB";
export const ROUTE_STATUS_METRIC_PROCESS_NAME = `${getStationCode()}_${ROUTE_STATUS_TAB_METRIC_KEY}`;
export const RSWS_NODE_CONFIG_METRIC = "getNodeConfig";
export const RSWS_STATION_ROUTES_METRIC = "getStationRoutes";
export const RSWS_FETCH_ROUTES_METRIC = "fetchRoutesInformation";
export const RSWS_SIDELINE_ROUTE_METRIC = "sidelineRoute";
export const RSWS_UNASSIGN_ROUTE_METRIC = "unassignRoute";



// WEBPACK FOOTER //
// ./src/components/util/MetricUtils.js